const SpecialtiesSection = () => {
  const specialties = [
    {
      name: "Behavioral Health",
      icon: (
        <svg className="w-20 h-20" viewBox="0 0 80 80" fill="none" stroke="currentColor" strokeWidth="2.5">
          {/* Head outline */}
          <path d="M25 20 Q20 25, 20 35 L20 50 Q20 60, 30 60 L50 60 Q60 60, 60 50 L60 35 Q60 25, 55 20 Q50 15, 40 15 Q30 15, 25 20 Z" strokeLinejoin="round" />
          {/* Brain pattern */}
          <path d="M30 25 Q35 22, 40 25 Q45 22, 50 25" strokeLinecap="round" />
          <path d="M28 32 Q33 30, 38 32" strokeLinecap="round" />
          <path d="M42 32 Q47 30, 52 32" strokeLinecap="round" />
          <circle cx="32" cy="40" r="2" fill="currentColor" />
          <circle cx="48" cy="40" r="2" fill="currentColor" />
          {/* Heart at bottom */}
          <path d="M35 52 L40 57 L45 52 Q48 49, 48 46 Q48 43, 45 43 Q42 43, 40 46 Q38 43, 35 43 Q32 43, 32 46 Q32 49, 35 52 Z" fill="currentColor" strokeWidth="1.5" />
        </svg>
      )
    },
    {
      name: "Cardiology",
      icon: (
        <svg className="w-20 h-20" viewBox="0 0 80 80" fill="none" stroke="currentColor" strokeWidth="2.5">
          {/* Heart shape */}
          <path d="M40 65 L18 43 Q12 37, 12 28 Q12 19, 19 15 Q26 11, 32 15 L40 23 L48 15 Q54 11, 61 15 Q68 19, 68 28 Q68 37, 62 43 Z" strokeLinejoin="round" />
          {/* ECG line inside heart */}
          <path d="M22 35 L28 35 L32 28 L36 42 L40 32 L44 38 L48 35 L58 35" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
        </svg>
      )
    },
    {
      name: "Neurosurgery",
      icon: (
        <svg className="w-20 h-20" viewBox="0 0 80 80" fill="none" stroke="currentColor" strokeWidth="2.5">
          {/* Brain outline */}
          <ellipse cx="40" cy="35" rx="22" ry="20" />
          {/* Brain details */}
          <path d="M25 30 Q30 25, 40 25 Q50 25, 55 30" strokeLinecap="round" />
          <path d="M25 40 Q30 45, 40 45 Q50 45, 55 40" strokeLinecap="round" />
          <path d="M40 25 L40 45" strokeWidth="1.5" opacity="0.5" />
          <path d="M25 35 L55 35" strokeWidth="1.5" opacity="0.5" />
          {/* Scalpel/surgical tool */}
          <path d="M35 55 L40 65 L45 55" strokeLinecap="round" strokeLinejoin="round" fill="currentColor" />
          <line x1="40" y1="50" x2="40" y2="65" strokeWidth="2" />
        </svg>
      )
    },
    {
      name: "Neonatology",
      icon: (
        <svg className="w-20 h-20" viewBox="0 0 80 80" fill="none" stroke="currentColor" strokeWidth="2.5">
          {/* Monitor/incubator */}
          <rect x="20" y="25" width="40" height="35" rx="3" />
          {/* Screen line */}
          <line x1="20" y1="35" x2="60" y2="35" />
          {/* Baby/heart icon */}
          <path d="M35 45 L40 50 L45 45 Q47 43, 47 41 Q47 39, 45 39 Q43 39, 40 42 Q37 39, 35 39 Q33 39, 33 41 Q33 43, 35 45 Z" fill="currentColor" strokeWidth="1.5" />
          {/* Monitor stand */}
          <line x1="30" y1="20" x2="30" y2="25" strokeLinecap="round" />
          <line x1="50" y1="20" x2="50" y2="25" strokeLinecap="round" />
          {/* Base wheels */}
          <circle cx="28" cy="62" r="3" strokeWidth="2" />
          <circle cx="52" cy="62" r="3" strokeWidth="2" />
        </svg>
      )
    },
    {
      name: "Nephrology",
      icon: (
        <svg className="w-20 h-20" viewBox="0 0 80 80" fill="none" stroke="currentColor" strokeWidth="2.5">
          {/* Left kidney */}
          <path d="M28 20 C24 24, 22 30, 22 40 C22 50, 24 56, 28 60 C26 58, 24 54, 24 48 C24 42, 26 36, 28 32 C26 28, 24 22, 24 18 C24 14, 26 10, 28 8" strokeLinecap="round" />
          <ellipse cx="28" cy="40" rx="6" ry="20" />
          {/* Right kidney */}
          <path d="M52 20 C56 24, 58 30, 58 40 C58 50, 56 56, 52 60 C54 58, 56 54, 56 48 C56 42, 54 36, 52 32 C54 28, 56 22, 56 18 C56 14, 54 10, 52 8" strokeLinecap="round" />
          <ellipse cx="52" cy="40" rx="6" ry="20" />
          {/* Inner details */}
          <ellipse cx="28" cy="40" rx="3" ry="12" opacity="0.5" />
          <ellipse cx="52" cy="40" rx="3" ry="12" opacity="0.5" />
        </svg>
      )
    },
    {
      name: "ENT",
      icon: (
        <svg className="w-20 h-20" viewBox="0 0 80 80" fill="none" stroke="currentColor" strokeWidth="2.5">
          {/* Head/face outline */}
          <path d="M30 20 Q25 22, 25 30 L25 50 Q25 58, 32 60 L48 60 Q55 58, 55 50 L55 30 Q55 22, 50 20 Q45 18, 40 18 Q35 18, 30 20 Z" strokeLinejoin="round" />
          {/* Eyes */}
          <circle cx="33" cy="35" r="3" fill="currentColor" />
          <circle cx="47" cy="35" r="3" fill="currentColor" />
          {/* Nose */}
          <path d="M40 38 L40 45 M37 45 L43 45" strokeLinecap="round" />
          {/* Mouth */}
          <path d="M33 50 Q40 53, 47 50" strokeLinecap="round" />
          {/* Ears */}
          <path d="M22 30 Q18 32, 18 38 Q18 44, 22 46" strokeLinecap="round" />
          <path d="M58 30 Q62 32, 62 38 Q62 44, 58 46" strokeLinecap="round" />
        </svg>
      )
    },
    {
      name: "Urgent Care",
      icon: (
        <svg className="w-20 h-20" viewBox="0 0 80 80" fill="none" stroke="currentColor" strokeWidth="2.5">
          {/* Phone receiver */}
          <path d="M25 30 Q20 32, 20 38 L20 42 Q20 48, 25 50 L30 50 Q35 48, 35 42 L35 38 Q35 32, 30 30 Z" strokeLinejoin="round" />
          <path d="M45 30 Q50 32, 50 38 L50 42 Q50 48, 55 50 L60 50 Q65 48, 65 42 L65 38 Q65 32, 60 30 Z" strokeLinejoin="round" />
          <path d="M35 40 Q40 38, 45 40" strokeLinecap="round" />
          {/* Plus sign in circle */}
          <circle cx="55" cy="25" r="10" strokeWidth="2.5" />
          <path d="M55 18 L55 32 M48 25 L62 25" strokeWidth="2.5" strokeLinecap="round" />
        </svg>
      )
    },
    {
      name: "Oncology",
      icon: (
        <svg className="w-20 h-20" viewBox="0 0 80 80" fill="none" stroke="currentColor" strokeWidth="2.5">
          {/* Magnifying glass */}
          <circle cx="35" cy="35" r="15" />
          <line x1="46" y1="46" x2="58" y2="58" strokeLinecap="round" strokeWidth="3" />
          {/* Cell/virus inside */}
          <circle cx="35" cy="35" r="8" strokeWidth="2" />
          <circle cx="28" cy="28" r="2" fill="currentColor" />
          <circle cx="42" cy="28" r="2" fill="currentColor" />
          <circle cx="28" cy="42" r="2" fill="currentColor" />
          <circle cx="42" cy="42" r="2" fill="currentColor" />
          {/* Gear/cog pattern */}
          <path d="M35 27 L35 43 M27 35 L43 35" strokeWidth="1.5" opacity="0.5" />
        </svg>
      )
    }
  ];

  return (
    <section className="bg-white py-10">
      <div className="max-w-[1330px] mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Heading */}
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold mb-4">
            <span className="text-blue-500">Our Medical</span>{' '}
            <span className="text-gray-900">Billing Services For</span>{' '}
            <span className="text-blue-500">Multi-Specialty</span>
          </h2>
          <p className="text-gray-600 text-base lg:text-lg max-w-5xl mx-auto leading-relaxed">
            Our USA based healthcare billing company provides comprehensive medical billing services for physicians and practices of all sizes 
            across 50+ specialties. Our specialty-focused teams help increase reimbursements. With multi-specialty billing experience, we 
            simplify your revenue cycle while reducing administrative burdens.
          </p>
        </div>

        {/* Specialties Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-0 mb-12 border border-gray-200 rounded-2xl overflow-hidden">
          {specialties.map((specialty, index) => (
            <div 
              key={index}
              className={`bg-white p-6 flex flex-col items-center text-center group hover:bg-blue-50 transition-all duration-300
                ${index < 4 ? 'border-b border-gray-200' : ''}
                ${index % 4 !== 3 ? 'border-r border-gray-200' : ''}
              `}
            >
              <div className="text-blue-600 mb-4 group-hover:scale-110 transition-transform duration-300">
                {specialty.icon}
              </div>
              <h3 className="text-base font-bold text-gray-900">{specialty.name}</h3>
            </div>
          ))}
        </div>

        {/* View More Button */}
        <div className="text-center">
          <button className="bg-blue-800 hover:bg-blue-700 text-white font-bold px-8 py-4 rounded-lg transition-colors shadow-lg inline-flex items-center">
            View More Specialties
            <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </button>
        </div>

      </div>
    </section>
  );
};

export default SpecialtiesSection;
